module.exports = __webpack_public_path__ + "img/pexels-pixabay-326410.eaf129ed.png";